export default "__VITE_PUBLIC_ASSET__1c286d41__"